























































import { computed, defineComponent, onBeforeMount, onBeforeUnmount, ref, set } from "@vue/composition-api";
import Component, { mixins } from "vue-class-component";
import { YotiIdVerificationSession } from "@scrile/api-provider/dist/api/YotiVerificationProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import WithUserVerification from "@/mixins/WithUserVerification";
import providers from "@/lib/api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseStepper from "@/components/BaseStepper";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import PayeeInfoButton from "./PayeeInfoButton.vue";
import PayoutForm from "./PayoutForm.vue";
import PersonalIdForm from "./PersonalIdForm.vue";
import PersonalInfoForm from "./PersonalInfoForm.vue";
import PromoteView from "./PromoteView";

interface StepData {
  step: number;
}

@Component({
  name: "PayeeInfoSetupView",
  components: {
    ModalView,
    PayoutForm,
    PersonalIdForm,
    PersonalInfoForm,
    PayeeInfoButton,
    BaseButton,
    BaseIcon,
    PageTitle,
    BaseStepper,
    PromoteView,
  },
})
export default class PayeeInfoSetupView extends mixins(WithAuthUser, WithUserVerification) {
  public submits: Record<string, () => Promise<any>> = {};

  public yotiIdVerificationSession: YotiIdVerificationSession | null = null;

  public showPromote = true;

  public valid = false;

  public loading = false;

  public sendingData = false;

  public current = 1;

  public currentStep(step: number) {
    return "step-" + step;
  }

  public get steps(): Record<string, StepData> {
    return {
      personalInfo: {
        step: 1,
      },
      sensitiveAgreement: {
        step: 2,
      },
      payeeInfo: {
        step: 3,
      },
    };
  }

  public get yotiIframeSrc(): string {
    if (!this.yotiIdVerificationSession) {
      return "";
    }
    return `https://api.yoti.com/idverify/v1/web/index.html?sessionID=${this.yotiIdVerificationSession.id}&sessionToken=${this.yotiIdVerificationSession.token}`;
  }

  public async handlePromoteClick(): Promise<void> {
    const yotiIdVerification = await providers.YotiVerificationProvider.get();
    if (yotiIdVerification.verified) {
      this.showPromote = false;
    } else {
      this.yotiIdVerificationSession = await providers.YotiVerificationProvider.start({
        data: { config: {} },
      });
    }
  }

  // Обработчик сообщений
  public handleWindowMessage(event: { data: { eventType: string } }): void {
    if (event.data.eventType === "SUCCESS") {
      this.showPromote = false;
    } else if (event.data.eventType === "ERROR") {
      this.yotiIdVerificationSession = null;
    }
  }

  public beforeMount(): void {
    window.addEventListener("message", this.handleWindowMessage);
  }

  public beforeUnmount(): void {
    window.removeEventListener("message", this.handleWindowMessage);
  }

  public handleTitleClick() {
    if (this.current === 1) {
      this.showPromote = true;
    } else {
      return this.current--;
    }
  }

  public async startUserVerification() {
    try {
      this.sendingData = true;
      await this.userVerificationStart(this.authUserStrict.id);
      this.$emit("form:finishStep");
      await this.userVerificationFindMyStatus();
      const { role, authorities } = await providers.UserProvider.getMyAuthorities();
      this.authUserUpdate({ ...this.authUserStrict, role }, authorities);
    } finally {
      this.sendingData = false;
    }
  }

  public async handleButtonClick(hasNext: boolean, step: number) {
    for (let key in this.steps) {
      if (this.steps[key].step !== step) {
        continue;
      }
      try {
        this.sendingData = true;
        await this.submits[key]?.();
      } catch (e) {
        /* eslint-disable no-console */
        console.error(e);
        return;
      } finally {
        this.sendingData = false;
      }
      if (hasNext) {
        this.loading = false;
        this.current = this.current + 1;
      } else {
        this.startUserVerification();
      }
    }
  }

  public setCb(stepName: string, cb: Promise<any>) {
    this.$set(this.submits, stepName, cb);
  }
}
